(function(){
  var d = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  d.classList.add('bz-js');
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  function init(root){
    (root || document).querySelectorAll('.bz-reveal:not(.is-in)').forEach(function(el){ io.observe(el); });
  }
  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();